<template>
  <generic-modal
    size="large"
    :title="$t('serbipagos configuration')"
    icon="building"
    image="/images/icons/serbipagos.jpg"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <generic-container
        v-bind:show_plus="true"
        icon="list"
        :title="$t('agreement list')"
        v-on:add="add_setting"
      >
        <div class="ui grid" v-if="setup.settings.length">
          <div class="four wide column">
            <div class="ui vertical fluid pointing menu" ref="tabs">
              <a
                class="item"
                :data-tab="'t' + idx"
                v-for="(setting, idx) in setup.settings"
                :key="idx"
              >
                <i
                  class="settings icon"
                  :class="{ blue: setting.is_default }"
                ></i>
                {{ setting.name }}
              </a>
            </div>
          </div>
          <div class="twelve wide stretched column">
            <div
              class="ui tab segment"
              :data-tab="'t' + idx"
              v-for="(setting, idx) in setup.settings"
              :key="idx"
            >
              <setting
                :setting="setting"
                @remove="remove_setting"
                ref="setting"
                :index="idx"
                :integration_files="integration_files"
              />
            </div>
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify, api_host } from "@/utils";
import { v4 } from "uuid";
import Setting from "./Setting";

export default {
  name: "SerbipagosConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
    Setting,
  },
  computed: {},
  data() {
    return {
      setup: {
        settings: [],
      },
      api_host: api_host,
      integration_files: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/serbipagos/configuration/do-save", {
          s: vm.setup,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    add_setting() {
      let vm = this;
      vm.setup.settings.push({
        name: vm.$t("unnamed"),
        provider: "",
        code: "",
        uuid: v4(),
        integration_file: "",
        // query_integration: "",
        // payment_integration: "",
        // reverse_integration: "",
        // query_integration: {
        //   css: "",
        //   js: "",
        //   html: "",
        // },
        identifiers: [
          { name: "iden01", large: "", short: "" },
          { name: "iden02", large: "", short: "" },
          { name: "iden03", large: "", short: "" },
          { name: "iden04", large: "", short: "" },
          { name: "iden05", large: "", short: "" },
          { name: "iden06", large: "", short: "" },
        ],
        values: [
          { name: "val01", large: "", short: "" },
          { name: "val02", large: "", short: "" },
          { name: "val03", large: "", short: "" },
          { name: "val04", large: "", short: "" },
          { name: "val05", large: "", short: "" },
          { name: "val06", large: "", short: "" },
        ],
      });
    },
    remove_setting(index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete setting?"),
        function() {
          vm.setup.settings.splice(index, 1);
        },
      );
    },
    error_uploading(err) {
      console.error(err);
    },
    end_uploading(index, file) {
      let vm = this;
      vm.setup.settings[index].file = file;
    },
    getIntegrationFiles() {
      let vm = this;
      return new Promise((resolve, reject) => {
        local_api(vm, "post", "/serbipagos/configuration/do-get-integrations")
          .then((rfiles) => {
            vm.integration_files = rfiles;
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/serbipagos/configuration/do-get")
      .then((conf) => {
        // console.log(conf);
        if (conf && conf.settings) vm.setup.settings = conf.settings;
        // if (conf && conf.database) vm.setup.database = conf.database;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    vm.getIntegrationFiles();
  },
  watch: {
    "setup.settings"() {
      let vm = this;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.tabs)
          .find(".item")
          .tab();

        vm.$refs.setting.forEach((element) => {
          element.init_tabs();
        });

        window.jQuery(vm.$refs.environment_dropdown).dropdown();
      }, 500);
    },
  },
  updated: function() {},
};
</script>
